import React, { useEffect } from "react";
import moment from "moment";

const ThreadMessage = ({ isUser, username, message, time }) => {
    const user = JSON.parse(window.localStorage.getItem("user"));
    var newName = "";
    useEffect(() => {
        if(username === user.fullname){
            newName = "Me"
        }
        else{
            newName = "PSBS Support"
        }
    }, []);
  return (
    <div className=" py-1 flex flex-col">
      <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
        <div className=" space-y-1">
          {/* Username */}
          <p className="text-xs md:text-sm text-gray-500">{username}</p>

          {/* Message */}
          <div
            className={`p-2 text-sm md:text-base text-white rounded-md ${
              isUser
                ? "bg-[#95989A] text-left"
                : "bg-[#BE1F18] text-left"
            }`}
          >
            {message}
          </div>

          {/* Time Ago */}
          <p className="text-[10px] md:text-xs text-gray-400">{moment(time).format("DD/MM/yyyy hh:mm A")}</p>
        </div>
      </div>
    </div>
  );
};

export default ThreadMessage;
